import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAdvertisement } from '../redux/slices/interfaceSlice';
import { getClubInfo } from '../http/clubsApi';
export const useClubInfo = () => {
  const idBranch = localStorage.getItem('id_club');
  const [data, setData] = useState<string | null>(null);
  const [advertisement, setAdvertisementText] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (advertisement) {
      dispatch(setAdvertisement(advertisement));
    }
  }, [advertisement, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await getClubInfo(idBranch);

        setData(response.data.cabinet_info_content);
        setAdvertisementText(response.data.cabinet_posts[0]);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      } finally {
        setIsLoading(false);
      }
    };
    if (idBranch) {
      fetchData();
    }
  }, [idBranch]);

  return { data, isLoading };
};
